import { InputAdornment, InputAdornmentProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CurrencyInputAdornment = styled(InputAdornment)<InputAdornmentProps>(({ theme }) => ({
  padding: '23px 14px',
  marginLeft: 0,
}));
